// ── User Login Audit — internal/vendor domain exclusion ─────────────────────
// Hardcoded, always on: these domains are never "fleet users", so their logins
// should never appear in the KPIs, chart, table, or export.

export const DEFAULT_EXCLUDED_DOMAINS = ['et-envue.com', 'geotab.com'];

export function isDomainExcluded(email: string): boolean {
  const lower = email.toLowerCase();
  return DEFAULT_EXCLUDED_DOMAINS.some((d) => lower.endsWith('@' + d));
}
